import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-forgot-password',
  templateUrl: './social-forgot-password.component.html',
  styleUrls: ['./social-forgot-password.component.scss']
})
export class SocialForgotPasswordComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
